import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import SeeAllLink from 'components/SeeAllLink';
import Hidden from '@material-ui/core/Hidden';
import _isEmpty from 'lodash/isEmpty';
import ListTitle from 'components/ListTitle';
import Divider from 'components/Divider';
import withAppContainer from 'components/WithAppContainer';
import { makeSelectAuth } from 'containers/Auth/selectors';
import withSizes from 'react-sizes';
import { getHomeNews } from '../actions';
import { makeSelectNews } from '../selectors';
import BigNewsCard from './News/BigNewsCard';
import SmallNewsCard from './News/SmallNewsCard';

const styles = theme => ({
  root: {
    [theme.breakpoints.down('400')]: {
      position: 'relative',
    },
  },
  viewMore: {
    display: 'flex',
    justifyContent: 'center',
  },
  smallCards: {
    paddingLeft: '20px !important',
    [theme.breakpoints.down('991')]: {
      paddingLeft: '8px !important',
    },
  },
});

function NewsList(props) {
  const { auth, news, classes, isMobile } = props;

  useEffect(() => {
    if (auth.isLoaded && _isEmpty(news)) {
      props.getHomeNews();
    }
  }, [auth, news]);

  if (_isEmpty(news) || _isEmpty(news.data)) {
    return null;
  }
  const title = 'Latest News';
  const { data } = news;
  const [item1, ...rest] = data;

  return (
    <Grid
      container
      spacing={2}
      className={classes.root}
      data-test-id="home-latest-news"
    >
      <Grid item xs={12}>
        <Grid container direction="row" justify="space-between">
          <Grid item xs={12} sm={8}>
            <ListTitle title={title} />
          </Grid>
          <Hidden xsDown>
            <SeeAllLink link="news" label="View All News" />
          </Hidden>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={6}>
        <BigNewsCard data={item1} />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.smallCards}>
        <Grid container>
          {rest.map(el => (
            <React.Fragment key={el.fields.slug}>
              {isMobile && (
                <Grid item xs={12}>
                  <Divider bottom={12} />
                </Grid>
              )}
              <SmallNewsCard data={el} key={el.fields.slug} />
            </React.Fragment>
          ))}
        </Grid>
      </Grid>
      <Hidden smUp>
        <Grid item xs={12} className={classes.viewMore}>
          <SeeAllLink link="news" isMobile bordered align="center" />
        </Grid>
      </Hidden>
    </Grid>
  );
}

NewsList.propTypes = {
  auth: PropTypes.object,
  news: PropTypes.object,
  classes: PropTypes.object,
  isMobile: PropTypes.bool,
  getHomeNews: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  auth: makeSelectAuth(),
  news: makeSelectNews(),
});

function mapDispatchToProps(dispatch) {
  return {
    getHomeNews: () => dispatch(getHomeNews()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 600,
});

export default compose(
  withConnect,
  withStyles(styles),
  withAppContainer,
  withRouter,
  withSizes(mapSizesToProps),
)(NewsList);
